/**
 * THIS FILE IS AUTO-GENERATED - DO NOT EDIT MANUALLY
 *
 * Generated by: scripts/generate-icons/extract-and-inline.mjs
 * Source: @central-icons-react v1.1.137
 *
 * @generated
 */

import { memo } from 'react'

import { cn } from '#lib/cn'

import { type IconProps, IconSize, iconSizeValues } from '../types'

export const IconCrossMedium = memo(function IconCrossMedium({
  size = IconSize.Medium,
  title,
  className,
  ref,
  ...props
}: IconProps) {
  return (
    <svg
      width={`${iconSizeValues[size]}px`}
      height={`${iconSizeValues[size]}px`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={!title}
      aria-label={title}
      className={cn('shrink-0', className)}
      ref={ref}
      {...props}
    >
      {title && <title>{title}</title>}
      <path
        d="M6.25 6.25L17.75 17.75M17.75 6.25L6.25 17.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
})
